var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-5 mt-5"},[_c('h4',{staticClass:"error--text"},[_vm._v("Er gaat iets mis! Bekijk uw antwoorden.")])])
}]

export { render, staticRenderFns }